import { BeneficiosType } from "@/components/types/BeneficiosType";

export const BeneficiosList: BeneficiosType[] = [
    {
        index: 0,
        url: '/assets/terra.png',
        desc: 'Melhor comunicação',
        label: 'Viaje com segurança, autonomia e conexão real com outras culturas.',
    },
    {
        index: 1,
        url: '/assets/mala.png',
        desc: 'Oportunidades de carreira',
        label: 'Abra portas no mercado global e destaque-se em entrevistas e promoções.',
    },
    {
        index: 2,
        url: '/assets/raio.png',
        desc: 'Fluência em menos tempo',
        label: 'Aprenda comunicação prática e eficaz em poucos meses de estudo.',
    },
    {
        index: 3,
        url: '/assets/call.png',
        desc: 'Segurança para falar com nativos',
        label: 'Supere o medo de errar e ganhe confiança para se expressar.',
    },
    {
        index: 4,
        url: '/assets/conexao.png',
        desc: 'Conexão global',
        label: 'Construa amizades, contatos e oportunidades em qualquer lugar do mundo.',
    },
    {
        index: 5,
        url: '/assets/certificado.jpg',
        desc: 'Certificação reconhecida',
        label: 'Comprove sua evolução em inglês e fortaleça seu currículo com um certificado válido.',
    },
    
];